var _linearGradient, _clipPath, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMui(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49,
    height: 20,
    role: "img",
    "aria-label": "MUI",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MUI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 49,
    height: 20,
    fill: "#007fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,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"
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 335,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 210
  }, "MUI"), /*#__PURE__*/React.createElement("text", {
    x: 335,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 210
  }, "MUI"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMui);
export default __webpack_public_path__ + "static/media/mui.5277c4a6896ec3e3efa622949a8ea7af.svg";
export { ForwardRef as ReactComponent };